import {WarningInt} from "@app/interfaces/micro/passengerListStandby.interface";

export class RespDoCheckIn {
  pectabList: string;
  zoneBp: string;
  googleWalletBp: string;
  passengers: { passengerNameNumber: string;
    travelDocuments: string[];
    checkinStatusBySegment:any[]
    zone: any
    googleWalletPass: any;
  }[];
  warnings: WarningInt[] = [];

  constructor(resp: any) {
    this.pectabList = resp?.pectabList?.[0]?.pectab || '';
    this.passengers = [];
    this.warnings = resp?.warnings;
    if (resp && resp.passengers) {
      for (const passager of resp.passengers) {
        const travelDocs: string[] = [];
        const checkinStatusBySegment:any[] = [];
        const seats = [];

        for (const seg of passager.checkinStatusBySegment || []) {
          if (seg.boardingPass?.travelDoc) {
            travelDocs.push(seg.boardingPass?.travelDoc);
          }

          if(seg.checkinStatus) {
            checkinStatusBySegment.push(seg);
            this.zoneBp = seg.boardingPass?.zone;
            this.googleWalletBp = seg.boardingPass?.googleWalletPass;
          }
        }

        this.passengers.push({
          passengerNameNumber: passager.passengerNameNumber,
          checkinStatusBySegment:checkinStatusBySegment,
          travelDocuments: travelDocs,
          zone: this.zoneBp,
          googleWalletPass: this.googleWalletBp,
        });
      }
    }
  }
}
